export const BROADCAST = 'broadcastMessage';
export const DO_SEND_MESSAGE_TO_APP = '_sendMessageToApp';
export const GOTO_APP = 'gotoApp';
export const LOGOFF = 'logoff';
export const DO_NOVA_LOGOFF = 'doNovaLogoff';
export const REMOVE_SPLASH = 'removeSplash';
export const SEND_MESSAGE_TO_APP = 'sendMessageToApp';
export const SET_DIRTY_MESSAGE_ENABLED = 'setDirtyMessageEnabled';
export const SET_LOGOFF_URL = 'setLogoffUrl';
export const TIMEOUT = 'timeout';
export const UPDATE_APP_NAME = 'updateAppName';
export const UPDATE_DIRTY_STATE = 'updateDirtyFlag';

// is version still necessary?
export const VERSION = '5.0';
export const ORIGIN = window.location.origin;
//# sourceMappingURL=PostMessageCommand.js.map